module.exports = __webpack_public_path__ + "static/media/VISION-ETH.30c526d2.png";